/**
 * Podcast embed progress bar colors (track groove + played fill for live AudioPlayer).
 * Keep hex values in sync with `PODCAST_EMBED_PROGRESS_*` in
 * `app/services/tiptap/components/shared/podcast_episode_embed_methods.rb`.
 *
 * `LIGHT_*` / `DARK_*` match `textColorTone` on the node (widget chrome), not card luminance.
 */
export const PODCAST_EMBED_PROGRESS_LIGHT_TRACK = '#9CA3AF' as const;
export const PODCAST_EMBED_PROGRESS_LIGHT_FILL = '#4B5563' as const;
export const PODCAST_EMBED_PROGRESS_DARK_TRACK = '#818A96' as const;
export const PODCAST_EMBED_PROGRESS_DARK_FILL = '#374151' as const;
